module.exports = __webpack_public_path__ + "img/25.75e3db1f.jpg";